import { CommentHubAPIError } from 'shared-code/commenthub-api'

/**
 * The display-name rules and refusal copy shared by the Settings name editor
 * (`hooks/use-commenthub-profile`) and the sign-in dialog's "What should we call you?" step —
 * no React here, so the email-login flow module stays testable without the contexts.
 */
export const DISPLAY_NAME_MAX = 50

/** A commentHub profile refusal (rename, link, unlink) in reader words. */
export function profileErrorMessage(e: unknown, fallback: string): string {
  const code = e instanceof CommentHubAPIError ? e.code : null
  const status = e instanceof CommentHubAPIError ? e.status : 0
  let msg = fallback
  if (code === 'INVALID_DISPLAY_NAME') {
    msg = 'That name can’t be used. Try 1–50 characters without special symbols.'
  } else if (code === 'LAST_IDENTITY') {
    msg = 'This is your only way to sign in. Link another account before removing it.'
  } else if (code === 'IDENTITY_IN_USE') {
    msg = 'That account is already linked to a different profile.'
  } else if (status === 429) {
    msg = 'Too many attempts. Please wait a moment and try again.'
  }
  return msg
}
